import React from 'react'
import { node, object } from 'prop-types'

import UserProvider from '@Context/User'
import CommanProvider from '@Context/Comman'

function ContextProvider({ children, initialGlobalState }) {
  return (
    <UserProvider>
      <CommanProvider>
        {/*<UserProvider initialState={initialGlobalState}> */}
        {children}
      </CommanProvider>
    </UserProvider>
  )
}

ContextProvider.propTypes = {
  children: node.isRequired,
  initialGlobalState: object,
}

ContextProvider.defaultProps = {
  cookies: undefined, // undefined on client side. Only provided on SSR
  initialGlobalState: undefined,
}

export default ContextProvider
